import { render } from "./UsageStatisticsCard.vue?vue&type=template&id=40d12ce6&scoped=true"
import script from "./UsageStatisticsCard.vue?vue&type=script&lang=js"
export * from "./UsageStatisticsCard.vue?vue&type=script&lang=js"

import "./UsageStatisticsCard.vue?vue&type=style&index=0&id=40d12ce6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40d12ce6"]])

export default __exports__